import Utility from "./Utility";

/* eslint-disable no-extend-native */
export {};
declare global {
    interface Array<T> {
        init1stDimNumber(length: number): void;
        init2ndDimNumber(length: number, value?: any): void;
        init2ndDimGeneric<U>(length: number, value?: any): void;
        init3rdDimNumber(length: number, value?: any): void;
        init3rdDimGeneric<U>(length: number, value?: any): void;
        init1stDimBoolean(length: number, defaultValue: boolean): void;
        init2ndDimBoolean(length: number, defaultValue: boolean): void;
        reset1stDimNumber(defaultValue?: number): void;
        reset1stDimBoolean(defaultValue?: boolean): void;
        reset2ndDimNumber(defaultValue?: number): void;
        reset2ndDimBoolean(defaultValue?: boolean): void;
        groupBy<U>(callback: (item: T) => U): Map<U, Array<T>>;
        sum(): number;
        avg(): number;
        max(defaultLow?: boolean): number;
        min(): number;
        distinct(): Array<T>;
        byteArrayType(): string;
        first(): T | undefined;
        last(): T | undefined;
        remove(value: T): void;
        replace(replaced: T, replacing: T): void;
        and(other: Array<T>): Array<T>;
        nand(other: Array<T>): Array<T>;
        average(): number;
        except(values: Array<T>): Array<T>;
        overlap(values: Array<T>): Array<T>;
        includesEvery(values: Array<T>): boolean;
        includesAny(values: Array<T>): boolean;
        equals(values: Array<T>): boolean;
        greater(values: Array<T>): boolean;
        greaterEqual(values: Array<T>): boolean;
        lesser(values: Array<T>): boolean;
        lesserEqual(values: Array<T>): boolean;
        download(): Promise<void>;
    }
}

if (!Array.prototype.init1stDimNumber) {
    Array.prototype.init1stDimNumber = function init1stDimNumber(
        this: Array<number>,
        length: number,
    ) {
        for (let index = 0; index < length; index++) this[index] = 0;
    };
}

if (!Array.prototype.init2ndDimNumber) {
    Array.prototype.init2ndDimNumber = function init2ndDimNumber(
        this: Array<Array<number>>,
        length: number,
        value?: any,
    ) {
        for (let index = 0; index < this.length; index++) {
            this[index] = new Array<number>(length);
            for (let index2 = 0; index2 < length; index2++)
                if (!!value)
                    if (typeof value === "object")
                        this[index][index2] = structuredClone(value);
                    else this[index][index2] = value;
                else this[index][index2] = 0;
        }
    };
}

if (!Array.prototype.init2ndDimGeneric) {
    Array.prototype.init2ndDimGeneric = function init2ndDimGeneric<U>(
        this: Array<Array<U>>,
        length: number,
        value?: U,
    ) {
        for (let index = 0; index < this.length; index++) {
            this[index] = new Array<U>(length);
            for (let index2 = 0; index2 < length; index2++) {
                this[index][index2] = value;
            }
        }
    };
}

if (!Array.prototype.init3rdDimNumber) {
    Array.prototype.init3rdDimNumber = function init3rdDimNumber(
        this: Array<Array<Array<number>>>,
        length: number,
        length2: number,
        value?: any,
    ) {
        for (let index = 0; index < this.length; index++) {
            this[index] = new Array<Array<number>>(length);
            for (let index2 = 0; index2 < length; index2++) {
                this[index][index2] = new Array<number>(length2);
                for (let index3 = 0; index3 < length2; index3++)
                    this[index][index2][index3] = value ?? 0;
            }
        }
    };
}

if (!Array.prototype.init3rdDimGeneric) {
    Array.prototype.init3rdDimGeneric = function init3rdDimGeneric<U>(
        this: Array<Array<Array<U>>>,
        length: number,
        length2: number,
        value?: U,
    ) {
        for (let index = 0; index < this.length; index++) {
            this[index] = new Array<Array<U>>(length);
            for (let index2 = 0; index2 < length; index2++) {
                this[index][index2] = new Array<U>(length2);
                for (let index3 = 0; index3 < length2; index3++)
                    this[index][index2][index3] = value;
            }
        }
    };
}

if (!Array.prototype.init1stDimBoolean) {
    Array.prototype.init1stDimBoolean = function init1stDimBoolean(
        this: Array<boolean>,
        length: number,
        defaultValue: boolean = false,
    ) {
        for (let index = 0; index < length; index++) this[index] = defaultValue;
    };
}

if (!Array.prototype.init2ndDimBoolean) {
    Array.prototype.init2ndDimBoolean = function init2ndDimBoolean(
        this: Array<Array<boolean>>,
        length: number,
        defaultValue: boolean = false,
    ) {
        for (let index = 0; index < this.length; index++) {
            this[index] = new Array<boolean>(length);
            for (let index2 = 0; index2 < length; index2++)
                this[index][index2] = defaultValue;
        }
    };
}

if (!Array.prototype.reset1stDimNumber) {
    Array.prototype.reset1stDimNumber = function reset1stDimNumber(
        this: Array<number>,
        defaultValue: number = 0,
    ) {
        for (let index = 0; index < this.length; index++)
            this[index] = defaultValue;
    };
}

if (!Array.prototype.reset1stDimBoolean) {
    Array.prototype.reset1stDimBoolean = function reset1stDimBoolean(
        this: Array<boolean>,
        defaultValue: boolean = false,
    ) {
        for (let index = 0; index < this.length; index++)
            this[index] = defaultValue;
    };
}

if (!Array.prototype.reset2ndDimNumber) {
    Array.prototype.reset2ndDimNumber = function reset2ndDimNumber(
        this: Array<Array<number>>,
        defaultValue: number = 0,
    ) {
        for (let index = 0; index < this.length; index++)
            for (let index2 = 0; index2 < this[index].length; index2++)
                this[index][index2] = defaultValue;
    };
}

if (!Array.prototype.reset2ndDimBoolean) {
    Array.prototype.reset2ndDimBoolean = function reset2ndDimBoolean(
        this: Array<Array<boolean>>,
        defaultValue: boolean = false,
    ) {
        for (let index = 0; index < this.length; index++)
            for (let index2 = 0; index2 < this[index].length; index2++)
                this[index][index2] = defaultValue;
    };
}

if (!Array.prototype.groupBy) {
    Array.prototype.groupBy = function groupBy<T, U>(
        this: T[],
        callback: (item: T) => U,
    ) {
        return this.reduce((last, crnt) => {
            let key = callback(crnt);

            if (!last.has(key)) last.set(key, new Array<T>(crnt));
            else last.get(key)?.push(crnt);

            return last;
        }, new Map<U, Array<T>>());
    };
}

if (!Array.prototype.sum) {
    Array.prototype.sum = function sum<T>(this: T[]): number {
        let result = 0;

        for (let item of this) result += Number(item);

        return result;
    };
}

if (!Array.prototype.avg) {
    Array.prototype.avg = function avg<T>(this: T[]): number {
        if (this.length === 0) return 0;

        let result = 0;

        for (let item of this) result = result + Number(item);

        return result / this.length;
    };
}

if (!Array.prototype.max) {
    Array.prototype.max = function max<T>(
        this: T[],
        defaultLow?: boolean,
    ): number {
        if (this.length === 0) return defaultLow ? 0 : Number.MAX_SAFE_INTEGER;

        let result = -1;

        for (let item of this) result = Math.max(result, Number(item));

        return result;
    };
}

if (!Array.prototype.min) {
    Array.prototype.min = function min<T>(this: T[]): number {
        if (this.length === 0) return -1;

        let result = Number.MAX_SAFE_INTEGER;

        for (let item of this) result = Math.min(result, Number(item));

        return result === Number.MAX_SAFE_INTEGER ? -1 : result;
    };
}

if (!Array.prototype.distinct) {
    Array.prototype.distinct = function distinct<T>(this: T[]): Array<T> {
        return Array.from(new Set(this));
    };
}

if (!Array.prototype.byteArrayType) {
    Array.prototype.byteArrayType = function byteArrayType<T>(
        this: T[],
    ): string {
        if (
            this[0] === 137 &&
            this[1] === 80 &&
            this[2] === 78 &&
            this[3] === 71 &&
            this[4] === 13 &&
            this[5] === 10 &&
            this[6] === 26 &&
            this[7] === 10
        ) {
            return "png";
        } else if (this[0] === 60) {
            return "svg";
        } else if (
            this[0] === 255 &&
            this[1] === 216 &&
            this[this.length - 2] === 255 &&
            this[this.length - 1] === 217
        ) {
            return "jpg";
        } else if (this[0] === 47 && this[1] === 49 && this[2] === 46) {
            return "gif";
        } else {
            return "";
        }
    };
}

if (!Array.prototype.first) {
    Array.prototype.first = function first<T>(this: T[]): T | undefined {
        return this[0];
    };
}

if (!Array.prototype.last) {
    Array.prototype.last = function last<T>(this: T[]): T | undefined {
        if (this.length > 0) return this[this.length - 1];
        else return null;
    };
}

if (!Array.prototype.remove) {
    Array.prototype.remove = function remove<T>(this: T[], value: T): void {
        let index = this.indexOf(value);
        if (index >= 0) this.splice(index, 1);
    };
}

if (!Array.prototype.replace) {
    Array.prototype.replace = function replace<T>(
        this: T[],
        replaced: T,
        replacing: T,
    ): void {
        let index = this.indexOf(replaced);
        if (index >= 0) this.splice(index, 1, replacing);
        else this.push(replacing);
    };
}

if (!Array.prototype.and) {
    Array.prototype.and = function and<T>(
        this: Array<T>,
        other: Array<T>,
    ): Array<T> {
        let result = new Array<T>();

        for (let item of this) if (this.includes(item)) result.push(item);

        return result;
    };
}

if (!Array.prototype.nand) {
    Array.prototype.nand = function nand<T>(
        this: Array<T>,
        other: Array<T>,
    ): Array<T> {
        let result = new Array<T>();

        for (let item of this) if (!this.includes(item)) result.push(item);

        return result;
    };
}

if (!Array.prototype.average) {
    Array.prototype.average = function average(this: []) {
        if (this.length === 0) return this.length;

        let total = 0;
        for (let entry of this) total += entry;
        return total / this.length;
    };
}

if (!Array.prototype.except) {
    Array.prototype.except = function except<T>(
        this: Array<T>,
        values: Array<T>,
    ) {
        if (this.length === 0 || values.length === 0) return this;

        return this.filter(item => !values.includes(item));
    };
}

if (!Array.prototype.overlap) {
    Array.prototype.overlap = function overlap<T>(
        this: Array<T>,
        values: Array<T>,
    ) {
        return this.filter(item => values.includes(item));
    };
}

if (!Array.prototype.includesEvery) {
    Array.prototype.includesEvery = function includesEvery<T>(
        this: Array<T>,
        values: Array<T>,
    ) {
        return this.every(item => values.includes(item));
    };
}

if (!Array.prototype.includesAny) {
    Array.prototype.includesAny = function includesAny<T>(
        this: Array<T>,
        values: Array<T>,
    ) {
        return this.some(item => values.includes(item));
    };
}

if (!Array.prototype.equals) {
    Array.prototype.equals = function equals<T>(
        this: Array<T>,
        values: Array<T>,
    ) {
        return this.includesEvery(values) && this.length === values.length;
    };
}

if (!Array.prototype.greater) {
    Array.prototype.greater = function greater<T>(
        this: Array<T>,
        values: Array<T>,
    ) {
        return this.sum() > values.sum();
    };
}

if (!Array.prototype.greaterEqual) {
    Array.prototype.greaterEqual = function greaterEqual<T>(
        this: Array<T>,
        values: Array<T>,
    ) {
        return this.sum() > values.sum() || this.equals(values);
    };
}

if (!Array.prototype.lesser) {
    Array.prototype.lesser = function lesser<T>(
        this: Array<T>,
        values: Array<T>,
    ) {
        return this.sum() < values.sum();
    };
}

if (!Array.prototype.lesserEqual) {
    Array.prototype.lesserEqual = function lesserEqual<T>(
        this: Array<T>,
        values: Array<T>,
    ) {
        return this.sum() < values.sum() || this.equals(values);
    };
}

export interface DownloadDefinition {
    name: string;
    data: string;
}

if (!Array.prototype.download) {
    Array.prototype.download = async function download(
        this: Array<DownloadDefinition>,
    ) {
        for (const item of this) {
            item.data.download(item.name);
            await Utility.sleep(10);
        }
    };
}

export {};
declare global {
    interface ArrayBuffer {
        toArray(): Array<number>;
        toBase64(): string;
        byteArrayType(): string;
        toBlob(): Blob;
    }
}

if (!ArrayBuffer.prototype.toArray) {
    ArrayBuffer.prototype.toArray = function toArray(
        this: ArrayBuffer,
    ): Array<number> {
        return [...new Uint8Array(this)];
    };
}

if (!ArrayBuffer.prototype.toBase64) {
    ArrayBuffer.prototype.toBase64 = function toBase64(
        this: ArrayBuffer,
    ): string {
        let binary = "";
        let bytes = new Uint8Array(this);
        let length = bytes.byteLength;

        for (let index = 0; index < length; index++)
            binary += String.fromCharCode(bytes[index]);

        return window.btoa(binary);
    };
}

if (!ArrayBuffer.prototype.byteArrayType) {
    ArrayBuffer.prototype.byteArrayType = function byteArrayType(
        this: ArrayBuffer,
    ): string {
        return [...new Uint8Array(this)].byteArrayType();
    };
}

if (!ArrayBuffer.prototype.toBlob) {
    ArrayBuffer.prototype.toBlob = function toBlob(this: ArrayBuffer): Blob {
        return new Blob([this]);
    };
}

export {};
declare global {
    interface Uint8Array {
        byteArrayType(): string;
        toBlob(): Blob;
    }
}

if (!Uint8Array.prototype.byteArrayType) {
    Uint8Array.prototype.byteArrayType = function byteArrayType(
        this: Uint8Array,
    ): string {
        return [...this].byteArrayType();
    };
}

if (!Uint8Array.prototype.toBlob) {
    Uint8Array.prototype.toBlob = function toBlob(this: Uint8Array): Blob {
        return new Blob([this as any]);
    };
}
